// Action Types
export const FETCH_MEETING_PREPS_REQUEST = "FETCH_MEETING_PREPS_REQUEST";
export const FETCH_MEETING_PREPS_SUCCESS = "FETCH_MEETING_PREPS_SUCCESS";
export const FETCH_MEETING_PREPS_FAILURE = "FETCH_MEETING_PREPS_FAILURE";

// Action Creators
export const FetchMeetingPrepsRequest = ({ clientName,accountName,userId,type}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_MEETING_PREPS_REQUEST,
      payload: { clientName, accountName, userId, type },
    });
  };
};
export const FetchMeetingPrepsSuccess = (data) => ({
  type: FETCH_MEETING_PREPS_SUCCESS,
  payload: data,
});
export const FetchMeetingPrepsFailure = (error) => ({
  type: FETCH_MEETING_PREPS_FAILURE,
  payload: error,
});
